/**
 * Turn an Azure AD userPrincipalName into something readable.
 */

const titleCase = (value: string): string =>
  value
    .split(/[.\-_]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export interface FormattedUser {
  /** Best-effort person name */
  name: string;
  /** Real organization domain for guests. Undefined for members. */
  domain?: string;
}

export const formatUpn = (upn?: string | null): FormattedUser => {
  if (!upn) return { name: 'Unknown' };

  const extIndex = upn.indexOf('#EXT#');
  if (extIndex !== -1) {
    const external = upn.slice(0, extIndex);
    const separator = external.lastIndexOf('_');
    if (separator !== -1) {
      return {
        name: titleCase(external.slice(0, separator)),
        domain: external.slice(separator + 1),
      };
    }
    return { name: titleCase(external) };
  }

  // Member: first.last@domain
  const [local] = upn.split('@');
  return { name: titleCase(local) };
};

/** Single-line label, including the organization for external users. */
export const formatUserLabel = (upn?: string | null): string => {
  const { name, domain } = formatUpn(upn);
  return domain ? `${name} (${domain})` : name;
};
